import { twJoin } from "tailwind-merge"
import React from "react"
import Icon from "@components/UI/Icon"

export const SliderArrow = ({
  direction,
  className,
  onClick,
}: {
  direction: "prev" | "next"
  className?: string
  onClick?: () => void
}) => (
  <div
    onClick={onClick}
    className={twJoin(
      className,
      "flex items-center justify-center",
      "bg-white rounded-64p",
      "w-48p h-48p",
      "1440:w-64p 1440:h-64p",
      "shadow-[0px_3.43px_2.75px_0px_rgba(35,_37,_87,_0.0093),_0px_8.69px_6.95px_0px_rgba(35,_37,_87,_0.0133),_0px_17.72px_14.18px_0px_rgba(35,_37,_87,_0.0167),_0px_36.5px_29.2px_0px_rgba(35,_37,_87,_0.0207)]",
      "hover:ease-in-out",
      "hover:duration-150",
      "group",
      "hover:bg-slate-blue-500",
      "[&_path]:fill-slate-blue-500",
      "[&_path:hover]:fill-white"
    )}
  >
    <Icon
      className={twJoin(
        "[&_path]:fill-slate-blue-500",
        "group-hover:[&_path]:fill-white",
        direction === "prev" ? "rotate-180" : ""
      )}
      name={"arrow3-right"}
      color={"neutral-900"}
      size={32}
    />
  </div>
)
